<template>
  <div class="headers">
    <div class="left disf disfac">
      <div class="disf disfac">
        <img src="@/assets/images/logo2.png" width="31px" height="28px">
        <div class="header-title" >大件物流数智平台</div>
      </div>

      <ul class="disf ml120 fs18">
        <li class="mr90 hLi" @click="goRouter(item, index)"  v-for="(item,index) in navList" :key="index">
         <span class="l" :class="{'actives': activePath === item.path}">{{item.name}}</span>
          <div class="w-subnav" v-if="item.children">
            <div class="w-subnav-item" v-for="(item2,index2) in item.children"  @click="goRouter(item2, index)" :key="index2">
              <span :class="{'actives': activePath === item2.path}">{{item2.name}}</span>
            </div>
          </div>
        </li>
      </ul>
    </div>
    <div class="right">
      <ul class="disf fs18" >
        <template v-if="userInfo && userInfo.account">
          <span class="mr20">{{ userInfo.simpleUserInfo.realName }}</span>
        </template>
        <template v-else>
          <a href="javascript:;" class="buts login-button" @click="goLogin()"><li>登录</li></a>
          <a href="javascript:;" class="buts bg3f register-button" @click="goRegister()"><li>注册</li></a>
        </template>
      </ul>
    </div>
  </div>
</template>
<script>
import {mapState} from 'vuex'
export default {
  name: 'index',
  data() {
    return {
      isMouse: false,
      activePath: '/',
      navList: [
        {
          name: '首页',
          path: '/',
          isMouse: ''
        },
        {
          name: '服务项目',
          path: '',
          isMouse: '',
          children: [
            {
              name: '智能选线',
              path: '/project/line'
            },
            {
              name: '智能填报',
              path: '/project/declare'
            },
            {
              name: '信息服务',
              path: '/project/msg'
            },
            {
              name: '数字路勘',
              path: '/project/szlk'
            },
          ]
        },
        {
          name: '操作台',
          path: '/operator/index',
          isMouse: ''
        },
        {
          name: '我的',
          path: '/user/index',
          isMouse: ''
        },
      ]
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  methods: {
    goRouter (item, index) {
      console.log(item, index)
      if (index === 2 || index === 3) {
         this.$goPath(item.path, true)
      } else {
        if (item.path) {
          this.$router.push({path: item.path})
          this.activePath = item.path
        }
      }

    },
    // 鼠标移出事件
    mouseout (item) {
      item.isMouse = false
    },
    // 鼠标移入事件
    mousemove (item) {
      item.isMouse = true
    },
    goRegister() {
      const basePath = process.env.VUE_APP_BASE_URL
      location.href = `${basePath}/register`
    },
    goLogin() {
      const basePath = process.env.VUE_APP_BASE_URL
      const local = location.origin
      location.href = `${basePath}/login?redirectUrl=${local}`
    }
  },
  mounted() {
    this.activePath = this.$route.path
  }
}
</script>


<style scoped lang="less">
.headers{
  padding:0 20px;
  color: #000000;
  height: 80px;
  display: flex;
  justify-content: space-between;
  background-image: url("../../assets/images/headerBg.png");
  background-repeat: no-repeat;
  background-size: cover;
  align-items: center;
  position: fixed;
  width: 100%;
  min-width: 1200px;

  z-index: 999;
  top: 0;
  left: 0;
  .left{
    line-height: 40px;
    ul{
      li{
        cursor:pointer;
        position: relative;
        height: 80px;
        padding-top: 20px;
        .l{
          height: 60px;
          display: inline-block;
        }


        &:hover{
          .w-subnav{
            height: 165px;
            transition: height 0.6s;
          }
          .l{
            color: #0FB1C0;
            font-weight: bold;
            font-style: normal;

          }
        }
      }
    }
  }
}
.actives{
  color: #0FB1C0;
  font-weight: bold;
  font-style: normal;
}

.buts{
  padding: 5px 38px;
  border: 1px solid  #0FB1C0;
  border-radius: 4px;
  margin-right: 20px;
  color: #0FB1C0;
  text-decoration: none;
}

.login-button:hover {
  background: #ffffff;
  color: #0FB1C0;
}

.bg3f{
  border-color: #0FB1C0;
  background: #0FB1C0;
  color: #FFFFFF;
}

.register-button:hover {
  background: #ffffff;
  color: #0FB1C0;
}

.w-subnav{
  position: absolute;
  background: rgba(255, 255, 255,0.8);
  width: 150px;
  text-align: center;
  top: 75px;
  left: -50px;
  height: 0;
  animation-fill-mode: forwards;
  border-radius: 0 0 3px 3px;
  overflow: hidden;
  color: #000000;
  .w-subnav-item{
    &:hover{
      color: #0FB1C0;
      font-weight: bold;
      font-style: normal;
    }
  }
}
.mr20{
  margin-right: 20px;
}
.animate1{
  animation-name: example;
  animation-duration: 0.6s;
}
.animate2{
  animation-name: example2;
  animation-duration: 0.6s;
}
@keyframes example {
  from {height: 0;}
  to {height: 120px;}
}
@keyframes example2 {
  from {height: 120px;}
  to {height: 0;}
}
.header-title {
  display: inline-block;
  vertical-align: top;
  color: #000000;
  font-family: "PingFang SC";
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  border-right: 1px solid #ffffff;
  margin: 24px 0 22px 10px;
  padding-right: 10px;
  cursor: pointer;
}
</style>